$(document).ready(function () {
    'use strict';

    // TODO this js shouldn't be needed, this can be done in twig
    $('.collapsible').each( function () {
        $(this).find('li').first().find('h3').addClass('open');
        $(this).find('li').first().find('.collapsibleContent').show();
    });

    $('.collapsible h3').on('click', function() {
        $(this).parent().find('.collapsibleContent').stop(true, true).slideToggle();
        $(this).toggleClass('open');
    });
});